import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import Select from 'src/components/Select';
import TextField from 'src/components/TextField';
import { ReturnType } from 'src/types/return';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import AutocompleteTextField from 'src/components/AutocompleteTextField';
import DateTimePicker from 'src/components/DateTimePicker';
import Typography from 'src/components/Typography';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';
import colorOptionFce from 'src/utils/colorOptionFce';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: ReturnType;
    editErrors: FormErrorsType;
    newReturn: boolean;
    disableEdit: boolean;
    transportPaidByCodes: ConstantsCodeType[];
    sourceSysCodes: ConstantsCodeType[];
    returnStatusCodes: ConstantsCodeType[];
    allowedStatuses: ConstantsCodeType[];
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            {props.newReturn && (
                <GridItem cols={12}>
                    <Typography gutterBottom variant="h2">
                        {translate('returnDetail.returnTitle')}
                    </Typography>
                </GridItem>
            )}
            {!props.newReturn && (
                <GridItem cols={12}>
                    <TextField value={props.editData.RMA} label={translate('returnDetail.rma')} fullWidth disabled />
                </GridItem>
            )}
            <GridItem cols={12}>
                <TextField
                    value={props.editData.ESHOP_RETURN_ID}
                    error={props.editErrors.ESHOP_RETURN_ID}
                    onChange={(value, error) => props.onChange('ESHOP_RETURN_ID', value, error)}
                    name="ESHOP_RETURN_ID"
                    label={translate('returnDetail.eshopReturnId')}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            {!props.newReturn && (
                <GridItem cols={12}>
                    <DateTimePicker
                        type="dateTime"
                        value={props.editData?.CREATED_AT}
                        label={translate('returnDetail.createdAt')}
                        fullWidth
                        disabled
                    />
                </GridItem>
            )}
            {!props.newReturn && (
                <GridItem cols={12}>
                    <Select
                        options={props.sourceSysCodes}
                        value={props.editData?.SOURCE_SYS}
                        label={translate('returnDetail.sourceSystem')}
                        fullWidth
                        disabled
                    />
                </GridItem>
            )}
            <GridItem cols={12}>
                <AutocompleteTextField
                    value={props.editData.DESCRIPTION}
                    error={props.editErrors.DESCRIPTION}
                    onChange={(value, error) => props.onChange('DESCRIPTION', value || '', error)}
                    name="DESCRIPTION"
                    label={translate('returnDetail.returnDescription')}
                    fullWidth
                    multiline
                    disabled={props.disableEdit}
                    autoComplete="RETURN_DESCRIPTION"
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.SHIPPER}
                    error={props.editErrors.SHIPPER}
                    onChange={(value, error) => props.onChange('SHIPPER', value, error)}
                    name="SHIPPER"
                    label={translate('returnDetail.shipper')}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.SHIPPER_SERVICE_CODE}
                    error={props.editErrors.SHIPPER_SERVICE_CODE}
                    onChange={(value, error) => props.onChange('SHIPPER_SERVICE_CODE', value, error)}
                    name="SHIPPER_SERVICE_CODE"
                    label={translate('returnDetail.shipperServiceCode')}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.TRACKING_NUMBER}
                    error={props.editErrors.TRACKING_NUMBER}
                    onChange={(value, error) => props.onChange('TRACKING_NUMBER', value, error)}
                    name="TRACKING_NUMBER"
                    label={translate('returnDetail.trackingNumber')}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={12}>
                <Select
                    options={props.transportPaidByCodes}
                    value={props.editData.TRANSPORT_PAID_BY}
                    error={props.editErrors.TRANSPORT_PAID_BY}
                    onChange={(value, error) => props.onChange('TRANSPORT_PAID_BY', value, error)}
                    name="TRANSPORT_PAID_BY"
                    label={translate('returnDetail.transportPaidBy')}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            {!props.newReturn && (
                <GridItem cols={12}>
                    <Select
                        options={props.returnStatusCodes}
                        editableOptions={props.allowedStatuses}
                        value={props.editData.STATUS}
                        error={props.editErrors.STATUS}
                        onChange={(value, error) => props.onChange('STATUS', value, error)}
                        label={translate('returnDetail.statusOfReturn')}
                        required
                        fullWidth
                        disabled={props.disableEdit}
                        optionStyleFce={colorOptionFce}
                    />
                </GridItem>
            )}
        </Grid>
    );
};

export default Detail;
